import request from '@/router/axios'

//创建试卷
export function createPaper (obj) {
  return request({
    url: '/exam/admin/paper-prototype',
    method: 'post',
    data: obj,
  })
}

//试卷详情
export function getPaperDetail (id) {
  return request({
    url: `/exam/admin/paper-prototype/${id}`,
    method: 'get',
  })
}

//试卷列表
export function getPaperList (param) {
  return request({
    url: '/exam/admin/paper-prototypes',
    method: 'get',
    params: param,
  })
}

//删除试卷
export function deletePaper (id) {
  return request({
    url: `/exam/admin/paper-prototype/${id}`,
    method: 'delete',
  })
}

//编辑试卷
export function editPaper (obj) {
  return request({
    url: `/exam/admin/paper-prototype/${obj.id}`,
    method: 'put',
    data: obj,
  })
}